exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myForm {\n  margin-top: 50px; }\n\n@media (max-width: 768px) {\n  .myForm {\n    padding-left: 30px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/contactus/contactus.component.scss
// module id = ../../../../../src/app/contactus/contactus.component.scss
// module chunks = main